import { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { UrlUtils } from 'src/utils';
import { IAppConfig, ICategory } from 'src/services/AppService';
import { categoryConfigSelector, pageSelector } from 'src/selectors/app';
import { Button, Container, Element, Icon, RouterLink } from 'src/components';
import Menu from 'src/components/menu';
import Scrollbars from 'src/components/scrollbar';
import { LocationSelect } from 'src/layout/breadcrumb/location';

interface IProps {
    isExpand: boolean;
    setIsExpand: (isExpand: boolean) => void;
    isSticky: boolean;
    config?: IAppConfig;
    navbarRef?: React.RefObject<HTMLDivElement>;
}

const categorySoccer: any = {
    name: 'Bóng đá',
    url: '/bong-da.epi',
    childs: [
        // {
        //     name: 'Euro 2024',
        //     url: '/bong-da/euro-giai-dau-150.epi',
        // },
        // {
        //     name: 'Copa America 2024',
        //     url: '/bong-da/copa-america-giai-dau-151.epi',
        // },
    ],
};

function NavbarExpand({
    isExpand,
    setIsExpand,
    isSticky,
    config,
    navbarRef,
}: IProps) {
    let categories = useSelector(categoryConfigSelector);
    const page = useSelector(pageSelector);
    const isPageContentDetail = UrlUtils.isContentDetailPage(page.type);
    const [showScrollbar, setShowScrollbar] = useState<boolean>(false);
    const [distance, setDistance] = useState(0);

    useEffect(() => {
        if (!isExpand) {
            setDistance(0);
            return;
        }
        const element = navbarRef?.current;

        if (!element) return;

        const rect = element.getBoundingClientRect();

        setDistance(window.innerHeight - rect.bottom);
    }, [isExpand]);

    const onClick = () => {
        setTimeout(() => setIsExpand(false), 100);
    };

    useEffect(() => {
        return () => {
            setIsExpand(false);
            document.body.classList.remove('noscroll');
        };
    }, []);

    useEffect(() => {
        if (isExpand) {
            if ((isPageContentDetail && isSticky) || !isPageContentDetail) {
                document.body.classList.add('noscroll');
            }
        } else {
            document.body.classList.remove('noscroll');
        }
    }, [isExpand, page, isSticky]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setShowScrollbar(true);
        }
    }, []);

    if (config?.categories) {
        categories = config.categories;
    }

    const renderChildCategories = (child: ICategory[] = []) => {
        return child.map((item: ICategory, index: number) => (
            <Menu.List.Item
                key={`child.${index}`}
                className={cn(
                    'child-category',
                    'block',
                    'text-[16px] leading-[20px]',
                    'md:text-[16px] md:w-[33.33%]',
                )}
            >
                <RouterLink
                    className={cn(
                        'block',
                        'pl-[32px]',
                        'max-md:py-[8px]',
                        'md:h-[50px] md:leading-[50px]',
                    )}
                    to={item.url}
                    onClick={onClick}
                    newTab={item.newTab}
                    title={item.name}
                >
                    <Element renderAs="span">{item.name}</Element>
                </RouterLink>
            </Menu.List.Item>
        ));
    };

    const renderCategories = useCallback(() => {
        return categories?.map((item: ICategory, index: number) => {
            return (
                <Menu.List.Item
                    key={`parent.${index}`}
                    className={cn(
                        'parent-category',
                        'relative leading-[26px]',
                        'max-md:pb-[10px]',
                        'md:flex md:border-b md:border-solid md:border-[#e9ecef]',
                    )}
                >
                    <RouterLink
                        className={cn(
                            'flex items-center',
                            'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                            'max-md:mx-[20px]',
                            'max-md:pt-[16px] max-md:pb-[8px]',
                            {
                                ['max-md:border-t max-md:border-solid max-md:border-[#f0f0f0]']:
                                    index !== 0,
                            },
                        )}
                        to={item.url}
                        title={item.name}
                        onClick={onClick}
                    >
                        <Element
                            className={'text-[18px] font-semibold'}
                            renderAs="span"
                        >
                            {item.name}
                        </Element>
                    </RouterLink>
                    <Menu.List
                        className={cn('md:flex md:flex-wrap md:w-[75%]')}
                    >
                        {renderChildCategories(item.childs)}

                        {/* giao-duc */}
                        {item.id === 59 &&
                            renderChildCategories([
                                {
                                    name: 'Tuyển Sinh 2026',
                                    url: '/tuyen-sinh-tag12842.epi',
                                },
                            ] as any)}
                    </Menu.List>
                </Menu.List.Item>
            );
        });
    }, [categories]);

    const renderMenu = () => {
        return (
            <>
                <Element
                    className={
                        'md:border-b-[10px] md:border-solid md:border-[#e9ecef] md:mb-[12px]'
                    }
                >
                    <Container className="max-xs:p-0">
                        <LocationSelect onClick={onClick} />
                    </Container>
                </Element>
                <Menu.List>
                    <Container className="max-xs:p-0">
                        <Element
                            className={cn(
                                'border-b-[8px] border-solid border-[rgba(0,0,0,0.03)]',
                            )}
                        >
                            <Menu.List.Item
                                className={cn(
                                    'parent-category',
                                    'relative leading-[26px]',
                                    'max-md:mb-[12px]',
                                )}
                            >
                                <RouterLink
                                    className={cn(
                                        'flex items-center grow',
                                        'h-[40px] leading-[40px]',
                                        'pr-[6px] pl-[16px]',
                                        'font-[500]',
                                        'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    )}
                                    title="Bóng đá"
                                    to="/bong-da.epi"
                                >
                                    <Icon
                                        className={cn(
                                            'flex items-center justify-center',
                                            'p-[6px] mr-[12px]',
                                            'text-[28px]',
                                            'bg-[rgba(0,0,0,0.05)]',
                                            'rounded-full',
                                        )}
                                        icon="new-utility-soccer"
                                    />
                                    <Element
                                        className={'text-[16px]'}
                                        renderAs="span"
                                    >
                                        Thông tin bóng đá
                                    </Element>
                                </RouterLink>
                                <Menu.List
                                    className={cn(
                                        'md:flex md:flex-wrap md:w-[75%] max-md:bg-[#fdf9e980]',
                                    )}
                                >
                                    {renderChildCategories(
                                        categorySoccer.childs,
                                    )}
                                </Menu.List>
                            </Menu.List.Item>
                            <Menu.List.Item
                                className={cn(
                                    'parent-category',
                                    'relative leading-[26px]',
                                    'max-md:mb-[12px]',
                                )}
                            >
                                <RouterLink
                                    className={cn(
                                        'flex items-center grow',
                                        'h-[40px] leading-[40px]',
                                        'pr-[6px] pl-[16px]',
                                        'font-[500]',
                                        'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    )}
                                    to="/tien-ich-gia-vang.epi"
                                    title="Giá vàng hôm nay"
                                >
                                    <Icon
                                        className={cn(
                                            'flex items-center justify-center',
                                            'p-[6px] mr-[12px]',
                                            'text-[28px]',
                                            'bg-[rgba(0,0,0,0.05)]',
                                            'rounded-full',
                                        )}
                                        icon="new-utility-gold"
                                    />
                                    <Element
                                        className={'text-[16px]'}
                                        renderAs="span"
                                    >
                                        Giá vàng hôm nay
                                    </Element>
                                </RouterLink>
                            </Menu.List.Item>
                            <Menu.List.Item
                                className={cn(
                                    'parent-category',
                                    'relative leading-[26px]',
                                    'max-md:mb-[12px]',
                                )}
                            >
                                <RouterLink
                                    className={cn(
                                        'flex items-center grow',
                                        'h-[40px] leading-[40px]',
                                        'pr-[6px] pl-[16px]',
                                        'font-[500]',
                                        'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    )}
                                    to="/tien-ich-thoi-tiet.epi"
                                    title="Thời tiết"
                                >
                                    <Icon
                                        className={cn(
                                            'flex items-center justify-center',
                                            'p-[6px] mr-[12px]',
                                            'text-[28px]',
                                            'bg-[rgba(0,0,0,0.05)]',
                                            'rounded-full',
                                        )}
                                        icon="new-weather-regular"
                                    />
                                    <Element
                                        className={'text-[16px]'}
                                        renderAs="span"
                                    >
                                        Thời tiết
                                    </Element>
                                </RouterLink>
                            </Menu.List.Item>
                            <RouterLink
                                to={'/tien-ich.epi'}
                                className={cn(
                                    'uppercase text-[14px] leading-[1] font-[500]',
                                    'h-[36px]',
                                    'flex items-center justify-center',
                                    'mt-[4px] mb-[12px]',
                                )}
                            >
                                <Icon
                                    icon="new-video-expand-regular"
                                    className="text-[18px] mr-[8px]"
                                />
                                <span>Xem thêm tiện ích</span>
                            </RouterLink>
                        </Element>

                        {renderCategories()}
                        <Menu.List.Item
                            className={cn(
                                'parent-category',
                                'relative leading-[26px]',
                                'max-md:pb-[10px]',
                                'md:flex md:border-b md:border-solid md:border-[#e9ecef]',
                            )}
                        >
                            <RouterLink
                                className={cn(
                                    'flex items-center',
                                    'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    'max-md:mx-[20px]',
                                    'max-md:pt-[16px] max-md:pb-[8px]',
                                    'max-md:border-t max-md:border-solid max-md:border-[#f0f0f0]',
                                )}
                                to="/audio.epi"
                                onClick={onClick}
                                title="Audio"
                            >
                                <Element
                                    className={'text-[18px] font-semibold'}
                                    renderAs="span"
                                >
                                    Audio
                                </Element>
                            </RouterLink>
                        </Menu.List.Item>
                    </Container>
                </Menu.List>
                <Element
                    className={cn(
                        'navbar-close',
                        'pt-[10px] pb-[100px]',
                        'text-center',
                    )}
                >
                    <Button
                        className={cn(
                            'flex items-center justify-center',
                            'text-[16px] font-[600]',
                            'w-[150px] h-[44px]',
                            'my-[8px] mx-auto px-[38px]',
                            'rounded-[8px]',
                            'uppercase',
                            'bg-[#e9ecef]',
                        )}
                        onClick={onClick}
                        title="Đóng"
                    >
                        Đóng
                    </Button>
                </Element>
            </>
        );
    };

    return (
        <Element
            className={twMerge(
                'navbar-menu-full',
                'hidden',
                'w-full h-[calc(100vh-90px)]',
                'bg-white',
                'text-black',
                'md:bg-white',
                cn({
                    ['block h-[calc(100vh-40px)]']: isExpand,
                }),
            )}
            style={distance > 0 ? { height: distance } : {}}
        >
            {(isPageContentDetail && !isSticky) || !showScrollbar ? (
                <>{renderMenu()}</>
            ) : (
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                >
                    {renderMenu()}
                </Scrollbars>
            )}
        </Element>
    );
}

export default memo(NavbarExpand);
